export default __webpack_public_path__ + "static-bigflip/media/offline-online-legal.a1f9f961.webp";